/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { ComponentLike, ContentValue } from '@glint/template';

import type { BvFormLayoutGroupSignature } from './group/index';
import type { BvFormLayoutItemSignature } from './item';
import type { BvStackSignature } from '../bv-stack';

export interface BvFormLayoutSignature {
  Args: {
    text?: ContentValue;
  };
  Blocks: {
    default: [
      {
        Group: ComponentLike<BvFormLayoutGroupSignature>;
        Item: ComponentLike<BvFormLayoutItemSignature>;
      }
    ];
  };
  Element: BvStackSignature['Element'];
}

const BvFormLayoutComponent = templateOnlyComponent<BvFormLayoutSignature>();

export default BvFormLayoutComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvFormLayout: typeof BvFormLayoutComponent;
    'bv-form-layout': typeof BvFormLayoutComponent;
  }
}
